import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsAutomationRoute: InvariantJiraRoute = {
	name: 'project-settings-automation',
	path: '/jira/software/projects/:projectKey/settings/automate',
};
